<div id="delete-compensation-container">
  <p class="heading-02-semi-bold">
    ¿Está seguro que desea eliminar permanentemente la jurisdicción? Esta acción
    será irreversible.
  </p>
</div>
